import React from "react";
import { Link } from "react-router-dom";
import RemotePagination from "../common/Table";
import Utility from "../common/Utility";
import { __t } from "../../locale/language";
import Can from "../common/AccessControl";
import Moment from "moment";
import $ from "jquery";
import CommonDelete from "../common/CommonDelete";

class EmailtemplateList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      data: [],
      sizePerPage: 10,
      total: 0,
      search: "",
      client_id: localStorage.getItem("client_id"),
      user_type: this.props.userPermissions.user_type,
      delete_id: ""
    };
    this.updateEmailtemplateList = this.updateEmailtemplateList.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.deleteEmailTemplate = this.deleteEmailTemplate.bind(this);
    this.delete_cnferm = this.delete_cnferm.bind(this);
    this.delete = this.delete.bind(this);
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  delete_cnferm(type) {
    console.log("Deleted Id " + this.state.delete_id);
    if (type == "yes") {
      this.deleteEmailTemplate(this.state.delete_id)
    }
    else {
      $("#alertshow").hide();
    }
  }
  
  delete(id) {
    this.setState({
      delete_id: id
    }, () => {
      $("#alertshow").css("display", "block")
    })
  }

  deleteEmailTemplate(id){
    console.log(id);
    console.log(this.token);
    Utility.ExecuteData("delete-email-tmpl", this.token, { id: id })
      .then(responseJson => {
        if (responseJson.code === 200) {
          console.log("Response JSON " + responseJson.code);
          this.updateEmailtemplateList(1, 10);
        } else {
          alert(__t("try_again"));
        }
      })
      .catch(error => {
        this.setState({ errors: true });
      });
  }

  client_id = localStorage.getItem("client_id");
  renderButtons(cell, row, rowIndex) {
    return (
      <span>
        <Can
          I={["update-email-tmpl"]}
          userPermissions={this.props.userPermissions.userPermissions}
        >
          <Link
            to={{
              pathname: `/email-template/update/${row.id}`,
              state: { id: `${row.id}` }
            }}
            className="btn btn-primary btn-sm"
          >
            <i className="fa fa-pencil" aria-hidden="true" /> {__t("edit")}
          </Link>
          
        </Can>
        &nbsp;
        <Can
              I={["delete-email-tmpl"]}
              userPermissions={this.props.userPermissions.userPermissions}
            >
            <button
              className="btn btn-primary btn-sm"
              onClick={() => {
                this.delete(row.id);
              }}
            >
              <i className="fa fa-trash" aria-hidden="true" /> {__t("delete")}
            </button>
        </Can>
         <div className="alert_oerlay" id="alertshow" style={{ "display": "none" }}  >

            <div className="alert_box info_back" >
              <i className="fa fa-question-circle info_txt fa_alert"></i>
              <h3 id="alert_prompt_msg"> {__t("delete_confirm")} </h3>
              <div className="flx_space_between wd70">
                <button className="btn btn-success info_btn" onClick={() => {
                  this.delete_cnferm("yes")
                }}>{__t("Yes")}</button>
                <button className="btn btn-success info_btn" onClick={() => {
                  this.delete_cnferm("no")
                }} >{__t("No")}</button>
              </div>
            </div>
              </div>
      </span>
    );
  }
  token = localStorage.getItem("token");
  handleTableChange = (type, { page, sizePerPage }) => {
    const currentIndex = (page - 1) * sizePerPage;
    //write fetch data function
    this.updateEmailtemplateList(page, sizePerPage);
  };
  updateEmailtemplateList(page = 1, sizePerPage = 10) {
    $("#alertshow").hide();
    Utility.ExecuteData("emailtemplatedata", this.token, {
      page: page,
      limit: sizePerPage,
      search: this.state.search,
      client_id: this.state.client_id,
      user_type: this.state.user_type
    }).then(data => {
      this.setState(() => ({
        page,
        data: data.data.rows,
        sizePerPage,
        total: data.data.count
      }));
    });
  }
  componentDidMount() {
    this.updateEmailtemplateList(1, 10);
  }
  render() {
    const { data, sizePerPage, page, total } = this.state;
    const columns = [
      { dataField: "title", text: __t("title") },
      { dataField: "subject", text: __t("subject") },
      { dataField: "status", text: "Status" },
      // {
      //   dataField: "created_at",
      //   text: __t("created_at"),
      //   formatter: cellContent =>
      //     Moment(cellContent).format("DD-MMM-YYYY HH:mm:ss")
      // },
      {
        dataField: "updated_at",
        text: __t("updated_at"),
        formatter: cellContent =>
          Moment(cellContent).format("DD-MMM-YYYY HH:mm:ss")
      },
      {
        dataField: "action",
        text: "Action",
        formatter: this.renderButtons.bind(this)
      }
    ];
    return (
      <Can
        I={["view-email-tmpl"]}
        userPermissions={this.props.userPermissions.userPermissions}
      >
    
        <div>
          <div className="row wrapper border-bottom white-bg page-heading">
            <div className="col-lg-10">
              <h2 style={{ marginTop: 10 }}>{__t("email_template_list")}</h2>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">{__t("dashboard")}</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/email-template">{__t("email_template")}</Link>
                </li>
                <li className="breadcrumb-item active">
                  <strong>{__t("email_template")}</strong>
                </li>
              </ol>
            </div>
          </div>
          <div className="wrapper wrapper-content animated fadeInRight">
            <div className="row">
              <div className="col-lg-12 ">
                <div className="ibox ">
                  <div className="ibox-title">
                    <div className="row from-control">
                      &nbsp; &nbsp; &nbsp;
                      <input
                        className="form-control col-md-3"
                        type="text"
                        name="search"
                        id="search_field"
                        onChange={this.handleChange}
                        placeholder={__t("search_by_title")}
                      />
                      &nbsp;
                      <input
                        className="btn btn-primary"
                        type="button"
                        onClick={() => {
                          this.updateEmailtemplateList();
                        }}
                        name="btn_search"
                        value={__t("search")}
                      />
                      &nbsp;
                      <h1></h1>
                      <input
                        className="btn btn-warning"
                        type="button"
                        onClick={() => {
                          this.setState({ search: "" }, () => {
                            this.updateEmailtemplateList();
                            document.getElementById("search_field").value = "";
                          });
                        }}
                        name="btn_search"
                        value={__t("clear")}
                      />
                      &nbsp;
                      <Can
                        I={["create-user"]}
                        userPermissions={
                          this.props.userPermissions.userPermissions
                        }
                      >
                        <Link
                          className="btn btn-primary"
                          to="/email-template/create"
                        >
                          {__t("create")}
                        </Link>
                      </Can>
                      <br />
                      &nbsp; &nbsp;
                      <strong style={{ marginTop: "10px" }}>
                        {__t("total_email_templates")}:{this.state.total}
                      </strong>
                    </div>
                  </div>
                  <div className="ibox-content">
                    {this.state.total > 0 ? (
                      <RemotePagination
                        columns={columns}
                        data={data}
                        page={page}
                        sizePerPage={sizePerPage}
                        totalSize={total}
                        onTableChange={this.handleTableChange}
                      />
                    ) : (
                      __t("no_record_found")
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Can>
    );
  }
}

export default EmailtemplateList;
